import { defineComponent as _defineComponent } from 'vue'
import { Stripe, SetupIntent, PaymentIntent, StripeElementsOptions, StripeElements } from '@stripe/stripe-js'
import VTextField from "@busy-human/vue-component-library/components/text-field.vue"
import Loader from './loader.vue';
import { PaymentMethods } from '@busy-human/opt-library'
import { httpsCallable } from 'firebase/functions'
import {functions} from '../util/firebase'
import { onMounted, ref } from 'vue';
import { useUserspace } from '@/store/userspace';

type Props = {
    stripe: Stripe | null
    price: number
    withdraw?: boolean
}
type Emits = {
    (e: 'close'): void
    (e: "createPaymentInfo", payment: PaymentMethods.Model): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'payment-input-window',
  props: {
    stripe: null,
    price: null,
    withdraw: { type: Boolean }
  },
  emits: ["close", "createPaymentInfo"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'close'): void
    (e: "createPaymentInfo", payment: PaymentMethods.Model): void,
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    stripe: Stripe | null
    price: number
    withdraw?: boolean
}

const env = ref(ENVIRONMENT)





const loading = ref(false)
const errorMessage = ref("")
const stripeFail = ref(false)


let setupIntent: SetupIntent | null = null
let elements: StripeElements | null = null
onMounted(async () => {
    if(props.stripe){
        loading.value = true
        const createSetupIntent = httpsCallable<{amount: number, currency: string, forPayouts?: boolean, testingData?: Object, uid?: string}, SetupIntent>(functions, 'createSetupIntent');
        // const testingOptions = {
        // }
        try{
        const result = await createSetupIntent({amount: props.price, currency: 'usd', forPayouts: props.withdraw, uid: useUserspace().uid /*, testingData: testingOptions */});

        setupIntent = result.data

        if(setupIntent?.client_secret){
            const { client_secret } = setupIntent
            const elementOptions: StripeElementsOptions = {
                // appearance: {theme: 'stripe'},
                clientSecret: client_secret
            }
            elements = props.stripe.elements(elementOptions);
            const element = elements.create('payment');
            element.mount("#stripe-frame")
        }else{
            console.warn('Setup Intent was not initiated Properly')
        }

        loading.value = false
        }catch(e){
            loading.value = false
            errorMessage.value = `Error Connecting to Stripe, Try again later`
            stripeFail.value = true
        }
    }
})

const createFailingPayment = () => {
    loading.value = true
    createPaymentMethod('pm_card_chargeCustomerFail', 'credit')
}

const confirmSetupIntent = async () => {
    loading.value = true
    if(props.stripe && setupIntent && elements){
        const {setupIntent, error} = await props.stripe.confirmSetup({
            elements,
            redirect: 'if_required'
        })

        if(error){
            console.warn("Error Confirming SetupIntent: ", error.message)
            errorMessage.value = `Error Creating Payment Method: ${error.message}`
            loading.value = false
            return
        }
        if(setupIntent?.client_secret){
            const result = await props.stripe.retrieveSetupIntent(setupIntent.client_secret)
            const setupIntentResult = result.setupIntent as SetupIntent
            switch (setupIntentResult.status) {
                case 'succeeded': {
                    if(setupIntentResult.payment_method){
                        let paymentMethodId = ''
                        if(typeof setupIntentResult.payment_method === 'object'){
                            paymentMethodId = setupIntentResult.payment_method?.id
                        }else{
                            paymentMethodId = setupIntentResult.payment_method
                        }
                        createPaymentMethod(paymentMethodId, 'credit')
                    }
                    break;
                }

                case 'processing': {
                    console.log("Processing payment details. We'll update you when processing is complete.")
                    loading.value = false
                    break;
                }

                case 'requires_payment_method': {
                    console.log("Failed to process payment details. Please try another payment method.")
                    loading.value = false
                    break;
                }
            }
        } else{
            console.log("No Client Secret")
            loading.value = false
        }
    }else{
        loading.value = false
    }

}

const paymentNickname = ref('')
const createPaymentMethod = (paymentMethodId: string, paymentType: PaymentMethods.MethodType) => {
    let newPaymentMethod: PaymentMethods.Model = PaymentMethods.Default();

    newPaymentMethod.paymentMethodId = paymentMethodId

    newPaymentMethod.type = paymentType

    newPaymentMethod.nickname = paymentNickname.value

    emit('createPaymentInfo', newPaymentMethod)
}


const __returned__ = { env, props, emit, loading, errorMessage, stripeFail, setupIntent, elements, createFailingPayment, confirmSetupIntent, paymentNickname, createPaymentMethod, Stripe, SetupIntent, PaymentIntent, StripeElementsOptions, StripeElements, VTextField, Loader, PaymentMethods, httpsCallable, functions, onMounted, ref, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})